import { mesLabel } from '../../lib/format';

/** Gráfico de barras do MRR - barra final em gradiente, demais em accent-soft. */
export function MrrChart({ historico }: { historico: { mes: string; mrr: number }[] }) {
  const max = Math.max(...historico.map((h) => h.mrr), 1);
  return (
    <div className="mt-8 flex h-[186px] items-end justify-between gap-5">
      {historico.map((h, i) => {
        const ultimo = i === historico.length - 1;
        return (
          <div key={h.mes} className="flex flex-1 flex-col items-center justify-end gap-[11px]">
            <div
              className="num text-[12.5px]"
              style={{ color: ultimo ? 'var(--accent)' : 'var(--ink-3)', fontWeight: ultimo ? 600 : 400 }}
            >
              {(h.mrr / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 0 })}
            </div>
            <div
              className="w-full max-w-[52px] rounded-t-[9px]"
              style={{
                height: `${Math.max(6, (h.mrr / max) * 100)}%`,
                background: ultimo ? 'linear-gradient(180deg,#12A574,#0E7C5A)' : 'var(--accent-soft)',
              }}
            />
            <div
              className="text-[11.5px]"
              style={{ color: ultimo ? 'var(--accent)' : 'var(--ink-3)', fontWeight: ultimo ? 500 : 400 }}
            >
              {mesLabel(h.mes)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
